module.exports = __webpack_public_path__ + "media/images/catalog-promo/promo455-f5c8239957125f1c60a289fa462a861d.jpg";